import { Box, Breadcrumbs, Text } from "@mantine/core";
import { BreadCrumbsPageBlockProps } from "components/_common/_page/_blocks/BreadCrumbsPageBlock/types";
import BootstrapGrid from "shared/ui/BootstrapGrid";
import { Link } from "shared/ui/_links/Link";
import styles from "./index.module.scss";

export const BreadCrumbsPageBlock = ({ items }: BreadCrumbsPageBlockProps) => {
  const breadCrumbs = items.map((item, index, array) => {
    const options = [
      { c: "gray", disabled: false },
      { c: "black", disabled: true },
    ];
    const isLastItem = index === array.length - 1;
    const c = options[Number(isLastItem)].c;
    const disabled = options[Number(isLastItem)].disabled;

    if (disabled || !item.href) {
      return (
        <Text key={index} c={c}>
          {item.title}
        </Text>
      );
    }

    return (
      <Link c={c} key={index} to={item.href}>
        {item.title}
      </Link>
    );
  });

  return (
    <BootstrapGrid.Row component={Box} bg={"white"} style={{ zIndex: 100 }}>
      <BootstrapGrid.Item>
        <Breadcrumbs classNames={styles}>{breadCrumbs}</Breadcrumbs>
      </BootstrapGrid.Item>
    </BootstrapGrid.Row>
  );
};
